<template>
	<v-card :flat="hideTitle" >
		<v-card-title v-if="!hideTitle">
			{{user.display_name}}
		</v-card-title>
		<v-card-text>
			<v-list flat color="lightGrey" class="rounded-lg">
				<v-list-item dense>
					<v-list-item-icon>
						<v-icon>mdi-hospital-building</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>				
							<span v-for="o in user.organisation" :key="o">
								{{organisations.find( org => org.id == o ).name}}
							</span>
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<v-list-item dense>
					<v-list-item-icon>
						<v-icon>mdi-email</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>				
							{{user.email}}
						</v-list-item-title>
					</v-list-item-content>
					<v-list-item-icon>
						<v-icon v-if="user.email_verified" color="green">mdi-account-check</v-icon>
						<v-icon v-else>mdi-account-clock</v-icon>
					</v-list-item-icon>
				</v-list-item>
			</v-list>
	
			<v-row>
				<v-col>
					<p class="mt-1 mb-1">Gruppenmitgliedschaften:</p> 
					<v-chip class="mr-2" v-for="group in userGroups" small :key="group.id" color="accent" close 
					@click="linkTo(`group/${group.id}`)"
					@click:close="removeMembership(group.id)">
						{{ group.name }}
					</v-chip>
				</v-col>
			</v-row>

			<v-row>
				<v-col>
					<p class="mt-1 mb-1">Zusammenarbeitsvorgänge:</p> 
					<v-chip  class="mr-2 mt-2" v-for="collab in userCollabs" small :key="collab.id" color="primary" :close="collab.type=='delegation'"
					@click="linkTo(`collaboration/${collab.id}`)"
					@click:close="removeMember(collab.id)">
						{{ collab.name }}
					</v-chip>
				</v-col>
			</v-row>
			<p class="mt-4 mb-0">
				<DateNote :date="user.last_login" name="Last login"></DateNote>
			</p>
			
			

		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
				<a :href="`mailto:${user.email}`" target='blank'><v-btn color="primary2" fab small ><v-icon color="white">mdi-email</v-icon></v-btn></a>
		</v-card-actions>
	</v-card>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import DateNote from "@/components/elements/DateNote"
	export default {
		name: "DisplaUser", 
		props: {
			hideTitle: {type: Boolean },
			user: {type: Object }
		},
		data: () => {
			return {

			}
		},
		components: {
			DateNote
		},
		computed: {
			...Vuex.mapState({
				organisations: state => state.organisations,				
				groups: state => state.groups,
				collaborations: state => state.collaborations
			}),
			userGroups(){
				var user_id = this.user.id
				return this.groups.filter( group => group.members.indexOf(user_id) > -1 )
			},
			userCollabs(){
				var user_id = this.user.id
				var matches = this.userGroups.map( u => u.id );
				matches.push( user_id );
				return this.collaborations.filter( collaborations => {
					return collaborations.members.some( id => matches.indexOf(id) > -1 )
				})
			}
		},
		methods: {
			removeCollab(id){
				this.$store.dispatch( "collaborations/removeMember", {member_id: this.user.id, collab_id: id} )
			},
			removeMembership(id){
				this.$store.dispatch( "groups/removeMember", {user_id: this.user.id, group_id: id} )
			}
		}

	}
</script>